import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  InitialStateType,
  RainTickerType,
  SetQueryPayloadActionType,
  SetIsCheckedRainTickerPayloadActionType,
  SetIsCheckedAllRainTickerPayloadActionType,
  SetModalPayloadActionType,
} from 'features/Location/@types/HubWeather'

export const SLICE_NAME = 'hubWeather'

export const initialState: InitialStateType = {
  isLoading: [],
  modal: {
    rainTickerBulk: [],
    mode: '',
    rainTickerSingle: {
      created_by: 0,
      id: '',
      updated_by: 0,
      isChecked: false,
      location_id: 0,
      location_name: '',
      status: false,
      uniqueID: '',
    },
  },
  rainTickers: [],
  query: { search: '', status: 0 },
  lastUpdatedRainTickers: '',
}

const hubWeather = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    reset: () => initialState,
    resetModal: (state) => {
      state.modal = initialState.modal
    },
    setIsLoading: (state, { payload }: PayloadAction<boolean>) => {
      if (payload) {
        state.isLoading.push(true)
      } else {
        state.isLoading.pop()
      }
    },
    setModal: (state, { payload }: PayloadAction<SetModalPayloadActionType>) => {
      state.modal = { ...state.modal, ...payload }
    },
    setQuery: (state, { payload }: PayloadAction<SetQueryPayloadActionType>) => {
      state.query = { ...state.query, ...payload }
    },
    setRainTickers: (state, { payload }: PayloadAction<RainTickerType[]>) => {
      state.rainTickers = payload
    },
    setLastUpdatedRainTickers: (state, { payload }: PayloadAction<string>) => {
      state.lastUpdatedRainTickers = payload
    },

    setIsCheckedRainTicker: (
      state,
      { payload: { uniqueID } }: PayloadAction<SetIsCheckedRainTickerPayloadActionType>,
    ) => {
      state.rainTickers = state.rainTickers.map((el) => ({
        ...el,
        isChecked: uniqueID === el.uniqueID ? !el.isChecked : el.isChecked,
      }))
    },
    setIsCheckedAllRainTicker: (
      state,
      { payload: { checked, uniqueID } }: PayloadAction<SetIsCheckedAllRainTickerPayloadActionType>,
    ) => {
      state.rainTickers = state.rainTickers.map((el) => ({
        ...el,
        isChecked: uniqueID.some((elSome) => elSome === el.uniqueID) ? checked : el.isChecked,
      }))
    },
  },
})

export default hubWeather.reducer
export const {
  reset,
  setQuery,
  setIsLoading,
  setRainTickers,
  setIsCheckedRainTicker,
  setIsCheckedAllRainTicker,
  setLastUpdatedRainTickers,
  setModal,
  resetModal,
} = hubWeather.actions
